import { memo, useEffect, useState } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, IconButton, Flex, VStack, Separator } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"

import { useApp } from "contexts/app"
import { useNavigate } from "react-router"
import { useAuth } from "contexts/auth"
const WithLoginPage = ({ children }) => {


    const navigate = useNavigate();
    const { showMenu, setShowMenu, showToast } = useApp();
    const { user, logout, showLogin } = useAuth();
    const goTo = (path) => {
        navigate(path);
        setShowMenu(false);
    }

    const loginApp = async () => {
        setShowMenu(false);
        var loggedInUser = await showLogin({});
        if (!loggedInUser) {
            return;
        }
        showToast({ description: "Đã đăng nhập", type: "success" });
        navigate(window.location);
    }

    if (user) {
        return children;
    }

    return (
        <div>
            <VStack>
                <Text>
                    Bạn cần đăng nhập
                </Text>
                <Button onClick={loginApp}>Đăng nhập</Button>
            </VStack>

        </div>
    )










    return (
        <div style={{ paddingBottom: 75 }}>

        </div >
    )
}

const withLogin = (child) => (<WithLoginPage>{child}</WithLoginPage>)



export default WithLoginPage;

